import React from 'react';
import { Tab, useColorModeValue } from '@chakra-ui/react';

export const PirateTab = ({ children, ...props }) => {
  const goldColor = 'rgba(255, 215, 0, 0.8)';
  const selectedBg = useColorModeValue('rgba(255, 215, 0, 0.1)', 'rgba(255, 215, 0, 0.15)');
  const hoverBg = useColorModeValue('rgba(255, 215, 0, 0.05)', 'rgba(255, 215, 0, 0.1)');

  return (
    <Tab
      {...props}
      px={6}
      py={3}
      fontWeight="semibold"
      color="gray.500"
      borderRadius="xl"
      _selected={{
        color: goldColor,
        bg: selectedBg,
        borderColor: goldColor,
      }}
      _hover={{
        bg: hoverBg,
      }}
    >
      {children}
    </Tab>
  );
};
